import { render, staticRenderFns } from "./SkillBoost.vue?vue&type=template&id=075d5e5f"
import script from "./SkillBoost.vue?vue&type=script&lang=js"
export * from "./SkillBoost.vue?vue&type=script&lang=js"
import style0 from "./SkillBoost.vue?vue&type=style&index=0&id=075d5e5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports